import type { GetThemeNormalized as SelectedTheme } from '@messenger/types'
import { escapeHtml } from '@messenger/utils'
import getThemeStylesForTemplate from './getThemeStylesForTemplate'
import type { CasePreferences } from '@messenger/types'

type HeaderTemplateProps = {
  key: keyof NonNullable<CasePreferences>
  headerValue: NonNullable<CasePreferences>[keyof NonNullable<CasePreferences>]
  selectedTheme: SelectedTheme | null
  editor?: Editor
}

export const headerTemplate = (headerTemplateProps: HeaderTemplateProps) => {
  const { key, headerValue, selectedTheme, editor } = headerTemplateProps

  const themeStyles = getThemeStylesForTemplate({
    selectedTheme,
    editor,
  })

  // A case-preference header is text, never markup.
  const headerSpan = `&#8202;<span class="mceNonEditable" data-template="${key}" style="${themeStyles}">${escapeHtml(String(headerValue ?? ''))}</span>&#8202;`

  return headerSpan
}
